/**
 * Web stub — Minerva is only available on Fire OS devices.
 * All metric calls are no-ops on web. Constants are duplicated for type safety.
 */

export function setOnSessionRotate(_cb: (() => void) | null): void {}

export function getAppSessionId(): string { return "web-stub"; }

export interface MetricEvent {
  feature: string;
  action: string;
  result?: string;
  counter?: number;
}

export const View = {
  Landing: "Landing",
  FTUE: "FTUE",
  StoryBuilder: "StoryBuilder",
  BookView: "BookView",
  Gallery: "Gallery",
  ComicViewer: "ComicViewer",
  ShareModal: "ShareModal",
  SharedWithYou: "SharedWithYou",
  SessionTakenOver: "SessionTakenOver",
  VPCEnablement: "VPCEnablement",
} as const;

export const Button = {
  Landing: { CreateStory: "CreateStory", ContinueStory: "ContinueStory", Gallery: "Gallery" },
  StoryBuilder: { Generate: "Generate", ClearStory: "ClearStory", TabStory: "TabStory", TabBook: "TabBook", StylePicker: "StylePicker" },
  Gallery: { OpenComic: "OpenComic", OpenProject: "OpenProject", SharedWithYou: "SharedWithYou" },
  ComicViewer: { Share: "Share", Back: "Back" },
  BookView: { ReadAloud: "ReadAloud", Redraw: "Redraw" },
  FTUE: { Continue: "Continue" },
  ShareModal: { SelectTarget: "SelectTarget", Confirm: "Confirm", Close: "Close" },
  SharedWithYou: { OpenComic: "OpenComic", SortToggle: "SortToggle", Close: "Close" },
  VPCEnablement: { ScanCode: "ScanCode", Exit: "Exit" },
} as const;

export const Muse = {
  ClientUserResponseTime: "ClientUserResponseTime",
  ClientTimeToFirstResponse: "ClientTimeToFirstResponse",
  VoiceStart: "VoiceStart",
  VoiceStop: "VoiceStop",
} as const;

export const Comic = {
  GenerateRequested: "GenerateRequested",
  GenerateComplete: "GenerateComplete",
  GenerateError: "GenerateError",
  TimeToFirstPage: "TimeToFirstPage",
  GeneratePageError: "GeneratePageError",
  PageViewed: "PageViewed",
} as const;

export const PageViewedSource = {
  Gallery: "gallery",
  Shared: "shared",
} as const;

export const Connection = {
  SocketConnect: "SocketConnect",
  SocketDisconnect: "SocketDisconnect",
  AuthError: "AuthError",
  VPCError: "VPCError",
  SessionTakenOver: "SessionTakenOver",
} as const;

export const ErrorToast = {
  Shown: "Shown",
} as const;

export const Session = {
  Start: "Start",
  End: "End",
  FTUEComplete: "FTUEComplete",
} as const;

export function trackView(_action: typeof View[keyof typeof View], _result?: string): void {}
export function trackButton<P extends keyof typeof Button>(_page: P, _button: typeof Button[P][keyof typeof Button[P]], _result?: string): void {}
export function trackMuseLatency(_action: typeof Muse[keyof typeof Muse], _ms: number): void {}
export function trackMuseEvent(_action: typeof Muse[keyof typeof Muse], _result?: string): void {}
export function trackComic(_action: typeof Comic[keyof typeof Comic], _result?: string, _counter?: number): void {}
export function trackConnection(_action: typeof Connection[keyof typeof Connection], _result?: string): void {}
export function trackErrorToast(_feature: string, _result: string): void {}
export function trackError(_feature: string, _result: string): void {}
export function trackModeration(_feature: string, _result: string): void {}
export function trackSession(_action: typeof Session[keyof typeof Session], _counter?: number): void {}
